"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartSortingWithIntl = exports.ChartSorting = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var ChartSortingDropdownBody_1 = require("./ChartSortingDropdownBody");
var ChartSortingDropdown_1 = require("./ChartSortingDropdown");
var Button_1 = require("../Button");
/**
 * @internal
 */
exports.ChartSorting = function (_a) {
    var sortConfig = _a.sortConfig, intl = _a.intl, bucketItemNames = _a.bucketItemNames, onCancel = _a.onCancel, onApply = _a.onApply, onClose = _a.onClose, enableRenamingMeasureToMetric = _a.enableRenamingMeasureToMetric;
    var _b = tslib_1.__read(react_1.useState(sortConfig.currentSort), 2), currentSort = _b[0], setCurrentSort = _b[1];
    var disabledExplanationTooltip = sortConfig.disabledExplanation;
    // Available Sorts - from which will generate dropdowns
    var availableSorts = sortConfig.availableSorts;
    var handleApply = react_1.useCallback(function () {
        onApply(currentSort);
    }, [currentSort]);
    var onSelect = function (item) {
        setCurrentSort(item);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ChartSortingDropdownBody_1.ChartSortingDropdownBody, { onClose: onClose },
            react_1.default.createElement("div", { className: "gd-sort-charting-dropdown-header s-sort-charting-dropdown-header" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { tagName: "div", id: "sorting.dropdown.header" })),
            react_1.default.createElement("div", { className: "section chart-sorting-body gd-sort-charting-dropdown" },
                react_1.default.createElement(ChartSortingDropdown_1.ChartSortingDropdown, { currentSort: currentSort, availableSorts: availableSorts, bucketItemNames: bucketItemNames, disabledExplanationTooltip: disabledExplanationTooltip, intl: intl, onSelect: onSelect, enableRenamingMeasureToMetric: enableRenamingMeasureToMetric })),
            react_1.default.createElement("div", { className: "chart-sorting-dropdown-footer" },
                react_1.default.createElement(Button_1.Button, { className: "gd-button-secondary gd-button-small s-sorting-dropdown-cancel", value: intl.formatMessage({ id: "cancel" }), onClick: onCancel }),
                react_1.default.createElement(Button_1.Button, { className: "gd-button-action gd-button-small s-sorting-dropdown-apply", value: intl.formatMessage({ id: "apply" }), onClick: handleApply })))));
};
/**
 * @internal
 */
exports.ChartSortingWithIntl = react_intl_1.injectIntl(exports.ChartSorting);
//# sourceMappingURL=ChartSorting.js.map